export default __webpack_public_path__ + "static/section_3_button_1-eb588737c436fdaca59700d0777dc6b1.png";